import variableColors from "@/base/global/variables/figma.colors.json";

export const paginationThemeToken: any = {
  //======================= SIZE ======================================//
  itemSize: 40,
  itemSizeSM: 32,
  fontSize: 14,
  fontSizeSM: 14,

  //======================= COLOR ======================================//
  itemActiveBg: variableColors["ColorFigmaComplementaryBlue50"],
  colorPrimary: variableColors["ColorFigmaComplementaryBlue50"],
  colorPrimaryHover: variableColors["ColorFigmaComplementaryBlue50"],
  colorPrimaryBorder: variableColors["ColorFigmaComplementaryBlue50"],
  colorTextDisabled: variableColors["ColorFigmaNeutralGrayscaleGray60Disabled"],
  colorActiveText: variableColors["ColorFigmaNeutralWhiteWhite100"],
  colorBgTextHover: "transparent",
  colorBgTextActive: "transparent",

  //======================= FONT ======================================//
  fontWeightStrong: 400,
};
